import React from 'react';

const Deposit = () => {
  return <>Deposit</>;
};

export default Deposit;
